module.exports = __webpack_public_path__ + "static/media/(V)-10-Capim-Dourado-bijuterias.54047baf.jpg";